import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

export const EventsContainer = styled.div`
  min-height: 100vh;
  background: #f8f8f8;
  padding: 4rem 2rem;
`;

export const EventsHeader = styled.div`
  text-align: center;
  margin-bottom: 6rem;
  opacity: 0;
  animation: ${fadeIn} 0.6s ease forwards;

  h1 {
    font-size: 3.5rem;
    font-weight: 500;
    margin-bottom: 1rem;
    background: linear-gradient(45deg, #000, #333);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 1.2rem;
    color: #666;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
`;

export const EventsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 3rem;
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
`;

export const EventCard = styled.div`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
  opacity: 0;
  animation: ${fadeIn} 0.6s ease forwards;
  animation-delay: ${props => props.index * 0.1}s;
  cursor: pointer;
  position: relative;

  &:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);

    .event-image img {
      transform: scale(1.1);
    }

    .event-date {
      background: #000;
      color: white;
    }
  }
`;

export const EventImage = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(to top, rgba(0,0,0,0.5), transparent);
  }
`;

export const EventDate = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  background: white;
  padding: 1rem;
  border-radius: 15px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

  .day {
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 0.2rem;
  }

  .month {
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

export const EventContent = styled.div`
  padding: 2rem;
`;

export const EventTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
  color: #000;
`;

export const EventInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
  color: #666;
  font-size: 0.9rem;

  div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  svg {
    font-size: 1.2rem;
  }
`;

export const EventDescription = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const EventButton = styled.button`
  background: transparent;
  border: 2px solid #000;
  color: #000;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: #000;
    color: white;
    transform: translateX(5px);
  }
`;

export const FilterSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 4rem;
  flex-wrap: wrap;
`;

export const FilterButton = styled.button`
  background: ${props => props.active ? '#000' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#000'};
  border: 2px solid #000;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #000;
    color: white;
    transform: translateY(-2px);
  }
`;

export const LoadingShimmer = styled.div`
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 1000px 100%;
  animation: ${shimmer} 2s linear infinite;
  height: ${props => props.height || '100%'};
  width: ${props => props.width || '100%'};
  border-radius: ${props => props.radius || '4px'};
  margin: ${props => props.margin || '0'};
`; 